module.exports = __webpack_public_path__ + "static/media/mcafloatflipped.83f4ca16.png";